"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatternPainter = void 0;
var PathBasedPainter_1 = require("../../PathBasedPainter");
var round_1 = require("../../../util/round");
/**
 * Implements drawing-related operations for patterns.
 */
var PatternPainter = /** @class */ (function (_super) {
    __extends(PatternPainter, _super);
    /**
     * @param loadImage An image loading function for the current environment.
     * @param getLoadingPlaceholder Provides an image to display while `pattern.url` is being loaded.
     */
    function PatternPainter(loadImage, getLoadingPlaceholder) {
        var _this = _super.call(this, "pattern") || this;
        _this.loadImage = loadImage;
        _this.getLoadingPlaceholder = getLoadingPlaceholder;
        /**
         * Keys used to store and retrieve resources in the {@link ObjectResourceStore}.
         */
        _this._keys = {
            image: {
                source: "image:source"
            },
        };
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    PatternPainter.prototype.loadResources = function (store, object) {
        var _this = this;
        store.load(this._keys.image.source, function () { return _this.loadImage(object.url); }, { hash: object.url });
    };
    PatternPainter.prototype.tracePath = function (ctx, store, object) {
        ctx.beginPath();
        ctx.rect(0, 0, round_1.round(object, this.scaledBaseWidthOf(object)), round_1.round(object, this.scaledBaseHeightOf(object)));
        ctx.closePath();
    };
    /**
     * Paints the pattern, or a loader if the image is loading or failed to load.
     */
    PatternPainter.prototype.paintFill = function (store, object) {
        var shouldRenderShadow = object.shadow && !object.stroke;
        var ctx = shouldRenderShadow
            ? store.layers.child("pre-shadow").clear().ctx
            : store.layers.result.ctx;
        ctx.save();
        this._paintPattern(ctx, store, object);
        ctx.restore();
        if (shouldRenderShadow) {
            this.applyShadowSettings(store.layers.result.ctx, object);
            store.layers.composite("pre-shadow", store.layers.result.ctx);
            this.removeShadowSettings(store.layers.result.ctx);
        }
    };
    /**
     * Paints the pattern or a placeholder, depending on the object's values and what
     * resources are currently loaded.
     */
    PatternPainter.prototype._paintPattern = function (ctx, store, object) {
        var sourceImage = store.require("image:source");
        if (sourceImage.status === "loaded") {
            this._paintInnerPattern(ctx, store, sourceImage.result, object);
            return;
        }
        this._paintImage(ctx, this.getLoadingPlaceholder(object), object);
    };
    /**
     * Paints the pattern.
     */
    PatternPainter.prototype._paintInnerPattern = function (ctx, store, image, object) {
        ctx.save();
        this.clipPath(ctx, store, object);
        ctx.scale(object.flipX ? -1 : 1, object.flipY ? -1 : 1);
        var targetImageWidth = object.scaleX * object.imageWidth;
        var targetImageHeight = object.scaleY * object.imageHeight;
        ctx.scale(targetImageWidth / image.width, targetImageHeight / image.height);
        var fillStyle = ctx.createPattern(image, "repeat");
        if (!fillStyle) {
            throw new Error("Failed to create pattern. Check the pattern image: "
                + "it may be corrupt, 0x0 in size, or an unsupported format.");
        }
        ctx.fillStyle = fillStyle;
        ctx.fill();
        ctx.restore();
    };
    /**
     * Paints an image stretched to the object's dimensions.
     */
    PatternPainter.prototype._paintImage = function (ctx, image, object) {
        ctx.save();
        ctx.drawImage(image, 0, 0, round_1.round(object, this.scaledBaseWidthOf(object)), round_1.round(object, this.scaledBaseHeightOf(object)));
        ctx.restore();
    };
    PatternPainter.prototype.shouldRepaint = function (previousData, newData) {
        var keys = ["imageWidth", "imageHeight", "url", "flipX", "flipY"];
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || keys.some(function (key) { return previousData[key] !== newData[key]; });
    };
    return PatternPainter;
}(PathBasedPainter_1.PathBasedPainter));
exports.PatternPainter = PatternPainter;
//# sourceMappingURL=PatternPainter.js.map